import * as React from "react";
import PropTypes from "prop-types";
const SvgNavigationWarningNormalSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M13 7v7h-2V7zM13 16h-2v2h2z" />
        <path d="M9.402 2.5c1.155-2 4.041-2 5.196 0l8.66 15c1.155 2-.288 4.5-2.598 4.5H3.34C1.03 22-.413 19.5.742 17.5zm3.464 1a1 1 0 00-1.732 0l-8.66 15A1 1 0 003.34 20h17.32a1 1 0 00.866-1.5z" />
      </g>
    </svg>
  )
);
SvgNavigationWarningNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgNavigationWarningNormalSmall;
